"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault").default;

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.firebase = void 0;

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/promise"));

// @TODO: Firebase doesn't export a list of providerIds they use
// But I found them here: https://github.com/firebase/firebase-js-sdk/blob/a5768b0aa7d7ce732279931aa436e988c9f36487/packages/rules-unit-testing/src/api/index.ts
// valid parameters as of 2021-06-12 at https://firebase.google.com/docs/reference/js/firebase.auth.GoogleAuthProvider#setcustomparameters
const hasPasswordCreds = options => {
  return options.email !== undefined && options.password !== undefined;
};

const firebase = client => {
  // Use a function to allow us to extend for non-oauth providers in the future
  const getProvider = providerId => {
    return new client.auth.OAuthProvider(providerId);
  };

  const applyProviderOptions = (provider, options) => {
    if (options.customParameters) {
      provider.setCustomParameters(options.customParameters);
    }

    if (options.scopes) {
      var _context;

      (0, _forEach.default)(_context = options.scopes).call(_context, scope => provider.addScope(scope));
    }

    return provider;
  }; // Firebase auth functions return a goog.Promise which as of 2021-05-12 does
  // not appear to work with try {await} catch blocks as exceptions are not caught.
  // This client returns a new standard Promise so that the exceptions can be
  // caught and no changes are required in common auth code located in AuthProvider.tsx


  const repackagePromise = fireBasePromise => {
    return new _promise.default((resolve, reject) => {
      fireBasePromise.then(result => resolve(result)).catch(error => reject(error));
    });
  };

  return {
    type: 'firebase',
    client,
    restoreAuthState: () => repackagePromise(client.auth().getRedirectResult()),
    login: (options = {
      providerId: 'google.com'
    }) => {
      // If argument provided is a string, it should be the oAuth Provider
      // Cast the provider string into the options object
      if (typeof options === 'string') {
        options = {
          providerId: options
        };
      }

      if (hasPasswordCreds(options)) {
        return repackagePromise(client.auth().signInWithEmailAndPassword(options.email, options.password));
      }

      const provider = getProvider(options.providerId || 'google.com');
      const providerWithOptions = applyProviderOptions(provider, options);
      return repackagePromise(client.auth().signInWithPopup(providerWithOptions));
    },
    logout: () => repackagePromise(client.auth().signOut()),
    signup: (options = {
      providerId: 'google.com'
    }) => {
      if (typeof options === 'string') {
        options = {
          providerId: options
        };
      }

      if (hasPasswordCreds(options)) {
        return repackagePromise(client.auth().createUserWithEmailAndPassword(options.email, options.password));
      }

      const provider = getProvider(options.providerId || 'google.com');
      const providerWithOptions = applyProviderOptions(provider, options);
      return repackagePromise(client.auth().signInWithPopup(providerWithOptions));
    },
    getToken: () => {
      const currentUser = client.auth().currentUser;

      if (currentUser) {
        return repackagePromise(currentUser.getIdToken());
      }

      return new _promise.default(() => {
        return null;
      });
    },
    getUserMetadata: async () => client.auth().currentUser
  };
};

exports.firebase = firebase;